<template>
  <div class="ai-friend-message">
    <ConfigTable ref="ct" :searchConfig="searchConfig" :tableColumns="tableColumns" :tableData="list" :total="total"
      @change="loadData" @view="view"></ConfigTable>
    <DialogDetail ref="dialog"></DialogDetail>
  </div>
</template>

<script>
import { changeDate } from '../../../utils/filter';
import ConfigTable from '@/components/config-table';
import aiFriendApi from '../../../api/aiFriendManage';
import DialogDetail from './components/DialogDetail.vue';

const searchConfig = [
  { type: 'input', placeholder: '角色ID搜索', key: 'aiRoleId' },
  { type: 'input', placeholder: '产品ID搜索', key: 'appId' },
  { type: 'input', placeholder: '会话ID搜索', key: 'id' },
  { type: 'input', placeholder: '用户ID搜索', key: 'userId' },
  { type: 'button', icon: 'search', placeholder: '搜索', key: 'search' },
]

const tableColumns = [
  { name: 'ID', key: 'id', width: 220, fixed: 'fixed' },
  { name: '应用ID', key: 'appId', width: 100 },
  { name: '角色ID', key: 'aiRoleId' },
  { name: '用户ID', key: 'userId' },
  { name: '用户唯一ID', key: 'uniqueId' },
  { name: '会话开始时间', key: 'startTime', valueHandler: changeDate },
  {
    name: '创建时间', key: 'createdAt', valueHandler: changeDate
  },
  {
    name: '更新时间', key: 'updatedAt', valueHandler: changeDate
  },
  { name: '操作', fixed: 'right', width: 100, actions: ['view'] },
];

export default {
  name: 'AiFriendDialogList',
  components: { ConfigTable, DialogDetail },
  data() {
    return {
      searchConfig,
      tableColumns,
      total: 0,
      list: [],
    };
  },
  watch: {

  },
  mounted() {

  },
  methods: {
    async loadData(params) {
      try {
        const r = await aiFriendApi.getAiDialogList(params)
        const data = r.data
        this.total = data.total
        this.list = data.list
      } catch (error) {
        console.error('搜索ai女友聊天记录失败：', error);
      }
    },
    view(row) {
      this.$refs.dialog.open(row)
    }
  }
};
</script>

<style lang="scss" scoped>
.ai-friend-message {

  /deep/ .el-button {
    padding: 9px 15px;
  }
}
</style>